import React from 'react';
import { theme } from '../constants';

import { hooks } from '../hooks';
import { custom } from '../custom';
import { product } from '../product';
import { Card, Row, Col, Button, Typography, Tag } from 'antd';
import { ShoppingCartOutlined } from '@ant-design/icons';

const { Title, Paragraph, Text } = Typography;

type Props = {
  item: any;
  isLast?: boolean;
  version?: number;
};

export const ProductHomeCard: React.FC<Props> = ({ isLast, item }) => {
  const navigate = hooks.useAppNavigate();
  return (
    <div
      onClick={() => {
        navigate('/product', { state: { item } });
      }}
      className="w-[180px] sm:w-[180px] rounded-xl shadow-xl cursor-pointer m-2 border border-gray-300"
      >
      <custom.ImageBackground
        imageUrl={item.image}
        style={{
          width: 180,
          height: 180,
          borderRadius: 12,
          marginBottom: 6,
          position: 'relative',
          backgroundSize: 'contain',
        }}
      >
        <product.ProductInWishlist
          item={item}
          style={{
            position: 'absolute',     // یا 'absolute' در صورت نیاز داخل container خاص
            left: 0,
            top: 0,
            padding: 5,
            zIndex: 2,          // مطمئن شو روی عناصر دیگه می‌افته
          }}
        />
        {item.is_available ? (
          <product.ProductInCart
            item={item}
            style={{
              position: 'absolute',
              margin: 10,
              left: 0,
              bottom: 0,
            }}
          />
        ) : (
          <Tag style={{
            position: 'absolute',
            margin: 10,
            left: 0,
            bottom: 46 - 10,
          }}
            className="rounded-full w-fit"
          >ناموجود</Tag>
        )}
      </custom.ImageBackground>
      <div
        style={{
          flexDirection: 'column',
          textAlign: 'right',
        }}
        className='pl-2 pt-2 pr-2'
      >
        <h6
          style={{
            marginTop: 0,
            marginBottom: 6,
            fontSize: 14,
            color: theme.colors.textColor,
            ...theme.fonts.Mulish_400Regular,
            fontWeight: 400,
          }}
        >
          {item.title}
        </h6>
        <product.ProductPrice item={item} />
      </div>
    </div>
  );
}
